module.exports = __webpack_public_path__ + "static/img/js.b0b9d54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/js.png
// module id = UvGp
// module chunks = 0